import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
   state: {
      s3: [],
      argomenti: [],
      areeSpeciali: []
   },

   mutations: {
      setS3 (state, arr) {
         state.s3 = arr;
      },

      setAreeSpeciali (state, arr) {
         state.areeSpeciali = arr;
      },

      setSearchArguments (state, arr) {
         state.argomenti = arr;
      },
   },
   getters: {
      getS3: state => {
         return state.s3;
      },
      getAreeSpeciali: state => {
         return state.areeSpeciali;
      },
      getArguments: state => {
         return state.argomenti;
      }
   }   
});
